var __rspack_ns_object = {"rE":"3.0.2"}